module.exports = __webpack_public_path__ + "img/car-dash2.bea2def3.png";